var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1260_4632)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3335 6.66634C6.96531 6.66634 6.66683 6.96482 6.66683 7.33301V13.333C6.66683 13.7012 6.96531 13.9997 7.3335 13.9997H13.3335C13.7017 13.9997 14.0002 13.7012 14.0002 13.333V7.33301C14.0002 6.96482 13.7017 6.66634 13.3335 6.66634H7.3335ZM5.3335 7.33301C5.3335 6.22844 6.22893 5.33301 7.3335 5.33301H13.3335C14.4381 5.33301 15.3335 6.22844 15.3335 7.33301V13.333C15.3335 14.4376 14.4381 15.333 13.3335 15.333H7.3335C6.22893 15.333 5.3335 14.4376 5.3335 13.333V7.33301Z",
    fill: "#18181B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6665 2.00033C2.48969 2.00033 2.32012 2.07056 2.1951 2.19559C2.07008 2.32061 1.99984 2.49018 1.99984 2.66699V8.66699C1.99984 8.8438 2.07008 9.01337 2.1951 9.1384C2.32012 9.26342 2.48969 9.33366 2.6665 9.33366H3.33317C3.70136 9.33366 3.99984 9.63214 3.99984 10.0003C3.99984 10.3685 3.70136 10.667 3.33317 10.667H2.6665C2.13607 10.667 1.62736 10.4563 1.25229 10.0812C0.877218 9.70613 0.666504 9.19743 0.666504 8.66699V2.66699C0.666504 2.13656 0.877217 1.62785 1.25229 1.25278C1.62736 0.877706 2.13607 0.666992 2.6665 0.666992H8.6665C9.19694 0.666992 9.70564 0.877706 10.0807 1.25278C10.4558 1.62785 10.6665 2.13656 10.6665 2.66699V3.33366C10.6665 3.70185 10.368 4.00033 9.99984 4.00033C9.63165 4.00033 9.33317 3.70185 9.33317 3.33366V2.66699C9.33317 2.49018 9.26293 2.32061 9.13791 2.19559C9.01288 2.07056 8.84332 2.00033 8.6665 2.00033H2.6665Z",
    fill: "#18181B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1260_4632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.c05bfe178f8e5ded8f21545c5d044d0c.svg";
export { ForwardRef as ReactComponent };